import React, { useState, useEffect } from 'react';

/**
 * MemuatKonten — tampilan sela saat potongan kode halaman sedang diunduh.
 *
 * Dipakai sebagai `fallback` <Suspense> DI DALAM layout (bukan di atas <Routes>),
 * supaya yang berganti cuma area isi — sidebar, header, dan tab tetap terpasang.
 * Kalau boundary-nya ditaruh di atas <Routes>, seluruh cangkang aplikasi ikut
 * lenyap sesaat tiap pindah menu, dan itu terasa seperti aplikasi nge-reload.
 *
 * Ditahan 150ms sebelum muncul: potongan yang sudah masuk cache browser biasanya
 * siap dalam beberapa milidetik, jadi tanpa jeda ini spinner cuma berkedip —
 * yang justru terasa lebih lambat daripada tidak ada apa-apa.
 */
export default function MemuatKonten({ delay = 150 }) {
  const [tampil, setTampil] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setTampil(true), delay);
    return () => clearTimeout(t);
  }, [delay]);
  if (!tampil) return null;
  return (
    <div className="flex items-center justify-center py-24" role="status" aria-label="Memuat halaman">
      <div className="border-2 rounded-full w-7 h-7 border-brand-200 border-t-brand-600 animate-spin" />
    </div>
  );
}
